import { useSelector } from "react-redux";
import { Space, Tooltip } from "antd";
import { LinkOutlined, CheckOutlined } from "@ant-design/icons";
import { columnTypes } from "../shared/table/columnTypes";
import { PreservableStateLink } from "../shared/PreservableStatePageWrapper";
import { filter } from "lodash";

export const renewalsColumns = (maskSensitiveData) => {
  return [
    {
      title: "Policy",
      dataIndex: "PolicyNumber",
      type: columnTypes.TEXT,
      width: 85,
      render: (value, record) => (
        <PreservableStateLink
          to={`/renewals/renewalform/${record.RenewalKey}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Plate",
      dataIndex: "PlateNumber",
      type: columnTypes.TEXT,
      width: 72,
      render: (value, record) => (
        <PreservableStateLink
          to={`/renewals/renewalform/${record.RenewalKey}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Updated Date",
      dataIndex: "DateModified",
      type: columnTypes.DATETIME,
      width: 180,
    },
    {
      title: "Assigned To",
      dataIndex: "AssignedTo",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Processing Stage",
      dataIndex: "ProcessingStageDesc",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Latest Note",
      dataIndex: "Note",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Expiry Date",
      dataIndex: "PolicyExpiryDate",
      type: columnTypes.DATE,
      width: 95,
    },

    {
      title: "Insured",
      dataIndex: "InsuredName",
      type: columnTypes.TEXT,
      width: 250,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Status",
      dataIndex: "PolicyStatusDesc",
      type: columnTypes.TEXT,
      width: 105,
    },

    {
      title: "PC1",
      dataIndex: "ProducerCode1",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 1",
      dataIndex: "ProducerName1",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "PC2",
      dataIndex: "ProducerCode2",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 2",
      dataIndex: "ProducerName2",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Phone",
      dataIndex: "CustomerHomePhone",
      type: columnTypes.PHONE,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 95,
    },
    {
      title: "Reminder Profile",
      dataIndex: "ReminderProfile",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Agency",
      dataIndex: "AgencyNumberAndName",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Processing Status",
      dataIndex: "ProcessingStatusDesc",
      type: columnTypes.TEXT,
      width: 120,
    },
  ];
};

export const remindersSentColumns = (maskSensitiveData) => {
  const deliveryStatusOptions = [
    "Pending",
    "Delivered",
    "Not Delivered",
    "N/A",
  ];

  return [
    {
      title: "Policy",
      dataIndex: "PolicyNumber",
      type: columnTypes.TEXT,
      width: 85,
      render: (value, record) => (
        <PreservableStateLink
          to={`/renewals/renewalform/${record.RenewalKey}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Plate",
      dataIndex: "PlateNumber",
      type: columnTypes.TEXT,
      width: 72,
      render: (value, record) => (
        <PreservableStateLink
          to={`/renewals/renewalform/${record.RenewalKey}`}
        >
          {value}
        </PreservableStateLink>
      ),
    },
    {
      title: "Updated Date",
      dataIndex: "DateModified",
      type: columnTypes.DATETIME,
      width: 180,
    },
    {
      title: "Last Text Processing Status",
      dataIndex: "LastTextReminderStatusDesc",
      type: columnTypes.TEXT_MULTI_FILTER,
      filterOptions: deliveryStatusOptions,
      width: 180,
    },
    {
      title: "Last Email Processing Status",
      dataIndex: "LastEmailReminderStatusDesc",
      type: columnTypes.TEXT_MULTI_FILTER,
      filterOptions: deliveryStatusOptions,
      width: 185,
    },
    {
      title: "Assigned To",
      dataIndex: "AssignedTo",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Processing Stage",
      dataIndex: "ProcessingStageDesc",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Latest Note",
      dataIndex: "Note",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Expiry Date",
      dataIndex: "PolicyExpiryDate",
      type: columnTypes.DATE,
      width: 95,
    },

    {
      title: "Insured",
      dataIndex: "InsuredName",
      type: columnTypes.TEXT,
      width: 250,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Status",
      dataIndex: "PolicyStatusDesc",
      type: columnTypes.TEXT,
      width: 105,
    },

    {
      title: "PC1",
      dataIndex: "ProducerCode1",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 1",
      dataIndex: "ProducerName1",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "PC2",
      dataIndex: "ProducerCode2",
      type: columnTypes.TEXT,
      width: 65,
    },
    {
      title: "Producer Name 2",
      dataIndex: "ProducerName2",
      type: columnTypes.TEXT,
      width: 175,
      render: (text) =>
        maskSensitiveData === true ? (
          <div className="blurry-text">{text}</div>
        ) : (
          text
        ),
    },
    {
      title: "Phone",
      dataIndex: "CustomerHomePhone",
      type: columnTypes.PHONE,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 95,
    },
    {
      title: "Reminder Profile",
      dataIndex: "ReminderProfile",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Agency",
      dataIndex: "AgencyNumberAndName",
      type: columnTypes.TEXT,
      width: 270,
    },
    {
      title: "Processing Status",
      dataIndex: "ProcessingStatusDesc",
      type: columnTypes.TEXT,
      width: 120,
    },
  ];
};

export const emailMessagesColumns = (onMessageClick) => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Subject",
      dataIndex: "Subject",
      type: columnTypes.TEXT,
      width: 100,
      render: (_, record) => (
        <a onClick={() => onMessageClick(record.Body)}>{record.Subject}</a>
      ),
    },
    {
      title: "Type",
      dataIndex: "ReasonDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "Sent Date",
      dataIndex: "UpdatedAt",
      type: columnTypes.DATE,
      width: 60,
    },
    {
      title: "Delivery Status",
      dataIndex: "DeliveryStatusDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "To",
      dataIndex: "Email",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 60,
    },
  ];
};

export const renewalTransactionsColumns = () => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Policy Number",
      dataIndex: "PolicyNumber",
      type: columnTypes.TEXT,
      width: 100,
      render: (value, record) => {
        const policyNumberContent =
          record.UserHasAccessToAgency === true ||
          record.UserHasAccessToAgency === 1 ? (
            <a
              href={`${process.env.REACT_APP_BASENAME}documents/updatedocumentform/${record.DocumentKey}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {value}
            </a>
          ) : (
            value
          );

        return (
          <Space size={4}>
            {(record.LinkedToRenewal === true ||
              record.LinkedToRenewal === 1) && (
              <Tooltip title="Linked to this renewal">
                <LinkOutlined style={{ color: "#1677ff" }} />
              </Tooltip>
            )}
            {(record.NextTermRenewal === true ||
              record.NextTermRenewal === 1) && (
              <Tooltip title="Next term renewal transaction">
                <CheckOutlined style={{ color: "#389e0d" }} />
              </Tooltip>
            )}
            {policyNumberContent}
          </Space>
        );
      },
    },
    {
      title: "Plate",
      dataIndex: "PlateNumber",
      type: columnTypes.TEXT,
      width: 80,
    },
    {
      title: "Txn Date",
      dataIndex: "EntryDateTime",
      type: columnTypes.DATETIME,
      width: 130,
    },
    {
      title: "Txn Type",
      dataIndex: "TransactionTypeDesc",
      type: columnTypes.TEXT,
      width: 130,
    },
    {
      title: "Agency",
      dataIndex: "AgencyNumberAndName",
      type: columnTypes.TEXT,
      width: 200,
    },
    {
      title: "Product",
      dataIndex: "Product",
      type: columnTypes.TEXT,
      width: 150,
    },
    {
      title: "Channel",
      dataIndex: "Channel",
      type: columnTypes.TEXT,
      width: 80,
    },
    {
      title: "Vehicle",
      dataIndex: "VehicleYear",
      type: columnTypes.TEXT,
      width: 150,
      render: (_, record) =>
        [record.VehicleYear, record.Make, record.Model]
          .filter(Boolean)
          .join(" "),
    },
    {
      title: "PC1",
      dataIndex: "Producercode1",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 65,
    },
    {
      title: "PC2",
      dataIndex: "Producercode2",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 65,
    },
    {
      title: "Effective Date",
      dataIndex: "PolicyEffectiveDate",
      type: columnTypes.DATE,
      width: 95,
    },
    {
      title: "Expiry Date",
      dataIndex: "PolicyExpiryDate",
      type: columnTypes.DATE,
      width: 95,
    },
  ];
};

export const agentNotesColumns = () => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  return [
    {
      title: "Note",
      dataIndex: "Note",
      type: columnTypes.TEXT,
      width: 100,
    },
    {
      title: "Processing Stage",
      dataIndex: "ProcessingStageDesc",
      type: columnTypes.TEXT,
      width: 60,
    },
    {
      title: "Agent",
      dataIndex: "AgentName",
      type: columnTypes.TEXT,
      render: (text) => (
        <div className={maskSensitiveData === true ? "blurry-text" : ""}>
          {text}
        </div>
      ),
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "UpdatedAt",
      type: columnTypes.DATE,
      width: 60,
    },
  ];
};
